import React, {Component} from 'react';
import { Link, NavLink} from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {getData} from '../../../services/index';
import Slider from 'react-slick';

class PurchaseHistory extends Component {
constructor (props) {
super (props);
this.state = {
		ListData: [],
		ListData1: [],
		ListData2: []
		};
	    if(!localStorage.getItem('userData')) {
		   this.props.history.push("login");
        }	
}

componentDidMount() {
setTimeout(function() {
document.querySelector(".loader-wrapper").style = "display: none";
}, 2000);

        var storedArray  = JSON.parse(localStorage.getItem("userData"));
        this.state.user_id = storedArray['data']['user_id'];	
		getData('Buycar/car_list',this.state).then((result) => {
		let responseJson = result;
			if(result['count']>0){
				this.setState({ 
					ListData: result['data']
				})				
				
			}
		});

		getData('Buycar/bike_list',this.state).then((result) => {
			let responseJson = result;
				if(result['count']>0){
					this.setState({ 
						ListData1: result['data']
					})				
					
				}
			});

			getData('auth/add_banner_list', this.state).then((result) => {
				let responseJson = result;
				if (responseJson.data) {
					this.setState({
						ListData2: result['data']
					})
				}
			});
}



render (){
return (
<div>
   <section className="authentication-page section-b-space margin-pd">
      <div className="_3lldG">
         <div className="_2u0oK _1iY8Y border-blue">
            <form>
               <div className="_3TzfO page_head">
                  <div className="_2QN4q">
                     <Link to={`${process.env.PUBLIC_URL}/`}>
                     <img src={`${process.env.PUBLIC_URL}/assets/images/icon/return_white.png`} alt="" /></Link>
                  </div>
                  <div className="_1leRb page_title">
                     Buy Cars & Bikes
                  </div>
                  <div className="b5NJg"></div>
               </div>
               <input type="submit" hidden=""/>
            </form>
         </div>
         <div className="_3mMtt dashboard m-plan">	

		  
		     <section className="renew-tab tab-product mt-20 purchase-tab restro" >
                <div className="row">
                    <div className="col-sm-12 col-lg-12">
                        <Tabs className="tab-content nav-material">
                            <TabList className="nav nav-tabs nav-material">
                                <Tab className="nav-item">
                                    <span className="nav-link active">
                                        <i className="icofont icofont-ui-home"></i>cars </span>
                                    <div className="material-border"></div>
                                </Tab>
                                <Tab className="nav-item">
                                    <span className="nav-link" ><i className="icofont icofont-man-in-glasses"></i>Bikes</span>
                                    <div className="material-border"></div>
                                </Tab>
                            </TabList>
							
							
                            <TabPanel className="tab-pane fade mt-4 show active">   
							<section className="renew-tab tab-product m-0 bg-purple tickets ">
								<div class="mt-0 mb-10 advertise mr-10">
									<Slider  className="slide-1 home-slider mt-10">
											{this.state.ListData2.map((banner) =>
												<div>
													<div className="home text-center" style={{backgroundImage: `url(${banner.image})`}}>
														<div className="container">
															<div className="row">
																<div className="col">
																	<div className="slider-contain">
																	
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											)} 
									</Slider>
								</div>
								<div className="row">
									<div className="col-sm-12 col-lg-12">	
									
									
									{this.state.ListData.map((list) => (
                                    <Link to={`${process.env.PUBLIC_URL}/car_details/${list.id}`}>
											<div className="res-div" role="button" tabIndex="0">
												<div className="res-img">
													<div className="bgimg" style={{backgroundImage: `url(${list.image})`}}>
													<div className="bgimg" style={{backgroundImage: `url(${list.image})`}}>
													</div>
													</div>
												</div>	
												<div className="res-info">
													<div className="_14v1V"><div className="nowrap">{list.title}</div></div>
													
													<div className="_14v1V nowrap car-rate"><i className="fa fa-inr" aria-hidden="true"></i>{list.rate}</div>
													<div className={`order_details del-close `} >{list.year} - {list.km_driven}</div>
													<div className={`order_details car-more`} >View More Details...</div>
												</div>					
											</div>
											</Link>	
											))}
                                          <div id="alert" className="m-b-10"></div> 	
                                   
											
									</div>
								</div>
							</section>  
											   
							   
                            </TabPanel>
                            
                            <TabPanel className="renew-tab2">
                            <section className="renew-tab tab-product m-0 bg-purple tickets ticket2 ">
								<div class="mt-0 mb-10 advertise mr-10">
										<Slider  className="slide-1 home-slider mt-10">
										{this.state.ListData2.map((banner) =>
												<div>
													<div className="home text-center" style={{backgroundImage: `url(${banner.image})`}}>
														<div className="container">
															<div className="row">
																<div className="col">
																	<div className="slider-contain">
																	
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											)} 
										</Slider>
									</div>
								<div className="row">
									<div className="col-sm-12 col-lg-12">	


									
                                    {this.state.ListData1.map((list) => (
                                    <Link to={`${process.env.PUBLIC_URL}/bike_details/${list.id}`}>
											<div className="res-div" role="button" tabIndex="0">
												<div className="res-img">
													<div className="bgimg" style={{backgroundImage: `url(${list.image})`}}>
													<div className="bgimg" style={{backgroundImage: `url(${list.image})`}}>
													</div>
													</div>
												</div>	
												<div className="res-info">
													<div className="_14v1V"><div className="nowrap">{list.title}</div></div>
													
													<div className="_14v1V nowrap car-rate"><i className="fa fa-inr" aria-hidden="true"></i>{list.rate}</div>
													<div className={`order_details del-close `} >{list.year} - {list.km_driven}</div>
													<div className={`order_details car-more`} >View More Details...</div>
												</div>					
											</div>
											</Link>	
											))}
                                          <div id="alert" className="m-b-10"></div> 


									</div>
								</div>
							</section>  
											
                            </TabPanel>
                            
                        </Tabs>
                    </div>
                </div>
            </section>
		 
         </div>
      </div>
   </section>
</div>
)
}
}
export default PurchaseHistory